(function () {
  'use strict';

  var digits = {0:'ᛟ',1:'ᛁ',2:'ᚷ',3:'ᛒ',4:'ᛞ',5:'ᛗ',6:'ᚹ',7:'ᛇ',8:'ᛜ',9:'ᛉ'};

  function init(root, form) {
    if (!root || root.dataset.stadfesteReady === 'true') return;
    var fields = {
      place: root.querySelector('[name="properties[Place name]"]'),
      region: root.querySelector('[name="properties[Region or country]"]'),
      keeper: root.querySelector('[name="properties[Keeper]"]'),
      year: root.querySelector('[name="properties[Year]"]'),
      inscription: root.querySelector('[name="properties[Inscription]"]')
    };
    if (!fields.place || !fields.region || !fields.year) return;

    function value(field) { return field ? field.value.trim() : ''; }
    function setText(key, text, fallback) {
      var element = root.querySelector('[data-stadfeste-preview="' + key + '"]');
      if (element) element.textContent = text || fallback;
    }
    function sync() {
      var year = value(fields.year).replace(/\D/g, '').slice(0, 4);
      if (fields.year.value !== year) fields.year.value = year;
      var cipher = year.split('').map(function (digit) { return digits[digit] || ''; }).join('');
      setText('place', value(fields.place).toUpperCase(), 'LOFOTEN');
      setText('region', value(fields.region).toUpperCase(), 'NORDLAND, NORWAY');
      setText('keeper', value(fields.keeper).toUpperCase(), 'THE HANSEN FAMILY');
      setText('year', year, '1987');
      setText('cipher', cipher, 'ᛁᛉᛜᛇ');
      setText('inscription', value(fields.inscription).toUpperCase(), 'WHERE THE SEA MEETS THE MOUNTAIN');
    }
    Object.keys(fields).forEach(function (key) {
      var field = fields[key];
      if (field) {
        field.addEventListener('input', sync);
        field.addEventListener('change', sync);
      }
    });
    if (form) form.addEventListener('submit', sync);
    root.dataset.stadfesteReady = 'true';
    sync();
  }

  window.FornvegrStadfeste = {init: init};
})();
